/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 22:37:52
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import DeclareMaintenanceApi from './api/declareMaintenanceApi';
import { createBEM, createNamespace } from 'src/util/bem';
import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
import Input from 'src/types/iview/Input';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import  DatePicker from 'src/types/iview/DatePicker';

let bem = createBEM('audit-maintenance');
export namespace AuditMaintenanceVOI {
    export interface PropsI {
        operate: string;
        sheetNumber: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        declare_type: string;
        operational_time: Integer;
        cause: string;
        sponsor_datetime: string;
        initiator: string;
        operationalSite: { deviceName: string; components: string[]}[];
        status: number;
        refuse_cause: string;
        audit_time: string
        auditor: string
        operateStatus: number
        timestamp:Integer;
    }
}

@Component
class AuditMaintenanceModal extends Vue.Component<AuditMaintenanceVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    sheetNumber!: string;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: AuditMaintenanceVOI.FormDataI = {
        declare_type: '123',
        operational_time: null,
        cause: '',
        initiator: '',
        sponsor_datetime: '',
        operationalSite: [],
        status: 1,
        refuse_cause: '',
        audit_time: '',
        auditor: '',
        operateStatus: 1,
        timestamp: null,
    };
    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if(this.formData.operateStatus===EnumMaintenanceAuditStatus.Reject.getId()&&!this.formData.refuse_cause) {
            return Toast.error('请填写审核不通过原因')
        }
        this.loading = true;
        let res = await DeclareMaintenanceApi.batchAudit({
            ids: [this.id],
            status: this.formData.operateStatus,
            refuse_cause: this.formData.operateStatus===EnumMaintenanceAuditStatus.Reject.getId()?this.formData.refuse_cause: '',
            timestamp: DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
        });
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        let { code, data } = await DeclareMaintenanceApi.searchDetail({ id: this.id });
        if (code === 0) {
            this.formData = {
                declare_type: data.declare_type,
                operational_time: data.operational_time,
                cause: data.cause,
                initiator: data.initiator,
                sponsor_datetime: data.sponsor_datetime,
                operationalSite: data.operational_site.data.map(i => ({
                    deviceName: i.operational_site,
                    components: i.operational_equipment,
                })),
                status: data.status,
                refuse_cause: data.refuse_cause,
                audit_time: data.audit_time,
                auditor: data.auditor,
                operateStatus: this.formData.operateStatus
            };
        }
    }

    render(h) {
        return (
            <Modal
                title={this.operate + '运维申报'}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={this.operate === EnumOperates.Detail.getName()}
            >
                <i-form ref="formValidate" labelWidth={140} class={createNamespace('detail-form')} model={this.formData}>
                    <form-item labelWidth={80} label="运维单号：" style="display: inline-block;width:50%">
                        {this.sheetNumber}
                    </form-item>
                    <form-item labelWidth={80} label="发起人" style="display: inline-block;width:20%">
                        {this.formData.initiator}
                    </form-item>
                    <form-item labelWidth={80} label="发起时间" style="display: inline-block;width:30%">
                        {this.formData.sponsor_datetime}
                    </form-item>
                    <form-item label="申报类型：" style="width:90%" class={createNamespace('mt15')}>
                        {this.formData.declare_type}
                    </form-item>
                    <form-item label="预计运维时长（h）：" style="width:90%">
                        {this.formData.operational_time}
                    </form-item>
                    <form-item label="原因：" style="display: inline-block;width:90%">
                        {this.formData.cause}
                    </form-item>
                    <form-item labelWidth={130} label="运维设备" class={createNamespace('mt15')} />
                    {this.formData.operationalSite.map((i, index) => {
                        return (
                            <div>
                                <form-item label="运维站点：" style="width:90%">
                                    {i.deviceName}
                                </form-item>
                                {i.components.map(sub => (
                                    <form-item label="运维设备：" style="width:90%">
                                        {sub}
                                    </form-item>
                                ))}
                            </div>
                        );
                    })}
                    <form-item label="审核时间" prop="timestamp" required type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.timestamp} />
                    </form-item>
                    <form-item labelWidth={130} label="审核情况" class={createNamespace('mt15')} />
                    <div v-if={this.operate === EnumOperates.Detail.getName()}>
                        <form-item label="审核状态：" style="width:90%">
                            {EnumMaintenanceAuditStatus.findId(this.formData.status).getName()}
                        </form-item>
                        <form-item label="审核人：" style="width:90%" v-if={this.formData.status !== EnumMaintenanceAuditStatus.UnAudit.getId()}>
                            {this.formData.auditor}
                        </form-item>
                        <form-item label="审核时间：" style="width:90%" v-if={this.formData.status !== EnumMaintenanceAuditStatus.UnAudit.getId()}>
                            {this.formData.audit_time}
                        </form-item>
                        <form-item label="不通过原因：" style="width:90%" v-if={this.formData.status === EnumMaintenanceAuditStatus.Reject.getId()}>
                            {this.formData.refuse_cause}
                        </form-item>
                    </div>
                    <div v-else>
                        <form-item label="" labelWidth={70} style="display: inline-block;width:32%">
                            <radio-group v-model={this.formData.operateStatus}>
                                <radio label={EnumMaintenanceAuditStatus.Audited.getId()}>
                                    {EnumMaintenanceAuditStatus.Audited.getName()}
                                </radio>
                                <radio label={EnumMaintenanceAuditStatus.Reject.getId()}>
                                    {EnumMaintenanceAuditStatus.Reject.getName()}
                                </radio>
                            </radio-group>
                        </form-item>
                        <form-item
                            labelWidth={10}
                            v-if={this.formData.operateStatus === EnumMaintenanceAuditStatus.Reject.getId()}
                            label=""
                            style="display: inline-block;width:60%"
                            prop="refuse_cause"
                        >
                            <Input placeholder="请输入审核不通过原因" v-model={this.formData.refuse_cause} type="textarea" />
                        </form-item>
                    </div>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertAuditMaintenanceModal(operate: string, id: number, sheetNumber: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AuditMaintenanceVOI.PropsI>(AuditMaintenanceModal)({
            id,
            operate,
            sheetNumber,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
